import axios from "axios";
import { serviceUrl } from "../../config";

const BACKEND_URL = serviceUrl;

export const uploadKYCDocs = async(userid, pin, agentID, base64Data, fileExtension, selectedSubTypeId, selectedSubType) => {
    try {
        const data = JSON.stringify({
            svc: "KYC_new",
            pid: "uploadKYCDocs",
            dat: {
                userid: userid,
                pin: pin,
                agentID: agentID,
                imagedata: base64Data,
                extension: fileExtension,
                kycTypeId: selectedSubTypeId,
                kycTypeName: selectedSubType,
            },
        });

        const config = {
            method: "post",
            url: BACKEND_URL,
            headers: {
                "Content-Type": "application/json",
            },
            data: data,
        };

        const response = await axios(config);
        return response.data;
    } catch (error) {
        console.log(error);
    }
}

export const uploadMerchantKYCDocs = async(userid, pin, agentID, base64Data, fileExtension, selectedSubTypeId, selectedSubType) => {
    try {
        const data = JSON.stringify({
            svc: "KYC_new",
            pid: "uploadMerchantKYCDocs",
            dat: {
                userid: userid,
                pin: pin,
                agentID: agentID,
                imagedata: base64Data,
                extension: fileExtension,
                kycTypeId: selectedSubTypeId,
                kycTypeName: selectedSubType,
            },
        });

        const config = {
            method: "post",
            url: BACKEND_URL,
            headers: {
                "Content-Type": "application/json",
            },
            data: data,
        };

        const response = await axios(config);
        return response.data;
    } catch (error) {
        console.log(error);
    }
}

export const getKYCDocs = async(userid, docs) => {
    try {
        const data = JSON.stringify({
            svc: "KYC_new",
            pid: "getKYCDocs",
            dat: {
                userid: userid,
                docs: docs
            },
        });
    
        const config = {
            method: "post",
            url: BACKEND_URL,
            headers: {
                "Content-Type": "application/json",
            },
            data: data,
        };
    
        const response = await axios(config);
        return response.data;
    } catch (error) {
        console.log(error);
    }
}

export const updateKYCInfo = async(
    agentID,
    pin,
    imagedata,
    userid,
    extension,
    country,
    subType,
    dataid,
    docid,
    subTypeDisplay,
    birthdate,
    expirydate,
    issuedate,
    stateid
) => {
        try {
            const data = JSON.stringify({
                svc: "KYC_new",
                pid: "updateKycInfo",
                dat: {
                    agentID: agentID,
                    pin: pin,
                    imagedata: imagedata,
                    userid: userid,
                    extension: extension,
                    country:country,
                    subType:subType,
                    dataid: dataid,
                    docid: docid,
                    docname: subTypeDisplay,
                    birthdate:birthdate,
                    expirydate:expirydate,
                    issuedate:issuedate,
                    stateid:stateid,
                },
            });
      
            const config = {
                method: "post",
                url: BACKEND_URL,
                headers: {
                    "Content-Type": "application/json",
                },
                data: data,
            };
      
            const response = await axios(config);
            return response.data;
        } catch (error) {
            console.log(error);
        }
}

export const userKYCStatusUpdate = async(
    agentID,
    pin,
    docid,
    userid,
    status,
    note,
    kycPolicyId
) => {
        try {
            const data = JSON.stringify({
                svc: "KYC_new",
                pid: "userKYCStatusUpdate",
                dat: {
                    agentID: agentID,
                    pin: pin,
                    docid: docid,
                    userid: userid,
                    status: status,
                    note: note,
                    policyid:kycPolicyId
                },
            });
      
            const config = {
                method: "post",
                url: BACKEND_URL,
                headers: {
                    "Content-Type": "application/json",
                },
                data: data,
            };
      
            const response = await axios(config);
            return response.data;
        } catch (error) {
            console.log(error);
        }
}

export const merchantKYCStatusUpdate = async(
    agentID,
    pin,
    docid,
    userid,
    status,
    note
) => {
        try {
            const data = JSON.stringify({
                svc: "KYC_new",
                pid: "merchantKYCStatusUpdate",
                dat: {
                    agentID: agentID,
                    pin: pin,
                    docid: docid,
                    userid: userid,
                    status: status,
                    note: note
                },
            });
      
            const config = {
                method: "post",
                url: BACKEND_URL,
                headers: {
                    "Content-Type": "application/json",
                },
                data: data,
            };
      
            const response = await axios(config);
            return response.data;
        } catch (error) {
            console.log(error);
        }
}
